import { fileActionTypes } from 'store/actionTypes';

const initialState = {
  isLoading: false,
  error: null,
};

const fileReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case fileActionTypes.UPLOAD_FILES_START:
    case fileActionTypes.DELETE_FILE_START:
    case fileActionTypes.UPLOAD_AVATAR_START:
      return {
        ...state,
        isLoading: true,
      };
    case fileActionTypes.UPLOAD_FILES:
    case fileActionTypes.DELETE_FILE:
    case fileActionTypes.UPLOAD_AVATAR:
      return {
        ...state,
        error: null,
        isLoading: false,
      };
    case fileActionTypes.UPLOAD_FILES_ERROR:
    case fileActionTypes.DELETE_FILE_ERROR:
    case fileActionTypes.UPLOAD_AVATAR_ERROR:
      return {
        ...state,
        error: payload,
        isLoading: false,
      };
    default:
      return state;
  }
};

export default fileReducer;
